const lowercaseFirstLetter = (string: string): string => {
  if (!(typeof string === 'string') || string.length === 0) {
    return '';
  }

  return String(string).charAt(0).toLowerCase() + String(string).slice(1);
};

export { lowercaseFirstLetter };
